import useDriftActions from 'src/hooks/useDriftActions';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { EditOrderPopupInner } from '../Popups/EditOrderPopup';
import Modal from './Modal';

const EditOrderModal = () => {
	const { hideEditOrderModal } = useDriftActions();

	const orderToEdit = useDriftStore(
		(s) => s.popups.editOrderPopupOptions.orderToEdit
	);

	return (
		<Modal onClose={hideEditOrderModal}>
			<Modal.Body>
				<Modal.Header
					onClose={hideEditOrderModal}
					showX
					className="xs:hidden sm:block"
				>
					<Modal.Title>Edit Order</Modal.Title>
				</Modal.Header>
				<Modal.Content>
					<EditOrderPopupInner
						existingOrder={orderToEdit}
						onClose={hideEditOrderModal}
					/>
				</Modal.Content>
			</Modal.Body>
		</Modal>
	);
};

export default EditOrderModal;
